// extracted by mini-css-extract-plugin
module.exports = {"row-container":"_3UEpL","row-wrapper":"_1yNFd","section-heading":"_16ZYN","wrapper":"ZpDTg"};